<survey-status
  icon="power"
  translationKey="surveyOffline"
  fallbackText="The survey is currently offline"
></survey-status>
